import { ComponentProps, FC, SVGProps } from 'react';

import { NavLink } from 'react-router';
import { twMerge } from 'tailwind-merge';

import { CardIcon, MenuIcon, ShareIcon } from '../assets';
import { COLORS, ROUTES, cn } from '../lib';

interface INavItem {
  label: string;
  value: string;
  Icon: FC<SVGProps<SVGSVGElement>>;
  disabled?: boolean;
}

const navItems: INavItem[] = [
  {
    label: 'Main',
    value: ROUTES.ROOT,
    Icon: MenuIcon,
  },
  {
    label: 'Payments',
    value: ROUTES.PAYMENTS,
    Icon: ShareIcon,
  },
  {
    label: 'Cards',
    value: ROUTES.CARDS,
    Icon: CardIcon,
    //disabled: true,
  },
];

const NavItem = ({ value, label, Icon, disabled }: INavItem) => {
  return (
    <NavLink
      viewTransition
      to={value}
      className={twMerge(disabled && 'pointer-events-none opacity-50')}
    >
      {({ isActive }) => (
        <div
          className={cn(
            'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-2xl p-4 text-base font-medium transition-all hover:cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
            { 'bg-base-500 text-base-500 shadow-sm': isActive },
          )}
        >
          <Icon
            color={isActive ? COLORS['icon-base-500'] : COLORS['base-100']}
          />
          {label}
        </div>
      )}
    </NavLink>
  );
};

export const Navbar = ({ className, ...props }: ComponentProps<'nav'>) => {
  return (
    <nav
      className={cn(
        '!z-50 inline-flex items-center justify-center rounded-[20px] bg-surface-00 p-1 text-base-100',
        className,
      )}
      {...props}
    >
      {navItems.map((props) => (
        <NavItem key={props.value} {...props} />
      ))}
    </nav>
  );
};
